import cn from 'classnames';

import { STANDARD_AS_PACKAGED_ACCESSIBILITY_LABEL, HEAT_AND_EAT_SLUG } from 'lib/constants';
import style from 'styles/components/mealDetails/NutritionFactsPanel.module.scss';

const SingleColumnNutritionTableHeadingRows = ({
  isTempo,
  menuCategory,
  dailyValueAsPackaged,
  dailyValueAsPrepared,
}) => {
  const isReadyToHeat = isTempo || menuCategory === HEAT_AND_EAT_SLUG;
  const abbr = isReadyToHeat
    ? 'Nutritional values for a prepared serving'
    : STANDARD_AS_PACKAGED_ACCESSIBILITY_LABEL;
  const calories = isTempo ? dailyValueAsPrepared.calories : dailyValueAsPackaged.calories;
  const caloriesAbbr = isTempo
    ? `${dailyValueAsPrepared.calories} as prepared calories`
    : `${dailyValueAsPackaged.calories} as packaged calories`;

  return (
    <tbody className={style.headingRows}>
      <tr>
        <th scope="col" colSpan="3">
          <span className="sr-only">Nutrient type</span>
        </th>
      </tr>
      <tr>
        <th scope="col" abbr={abbr} colSpan="3">
          <span className={style.helvBlk}>Amount per serving</span>
        </th>
      </tr>
      <tr className={style.caloriesRow}>
        <th className={style.helvBlk} scope="col">
          Calories
        </th>
        <td className={style.helvBlk} colSpan="2" abbr={caloriesAbbr}>
          {calories}
        </td>
      </tr>
    </tbody>
  );
};

SingleColumnNutritionTableHeadingRows.propTypes = {
  isTempo: PropTypes.bool.isRequired,
  menuCategory: PropTypes.string.isRequired,
  dailyValueAsPackaged: PropTypes.object.isRequired,
  dailyValueAsPrepared: PropTypes.object.isRequired,
};

const ThreeColumnNutritionTableHeadingRows = ({ dailyValueAsPackaged, dailyValueAsPrepared }) => {
  return (
    <tbody>
      <tr className={cn([style.columnSubtypes, style.columnHeaders])}>
        <th scope="col">
          <span className="sr-only">Nutrient type</span>
        </th>
        <th scope="col" colSpan="2" abbr={STANDARD_AS_PACKAGED_ACCESSIBILITY_LABEL}>
          <span className="whitespace-nowrap">
            As packaged<sup>**</sup>
          </span>
        </th>
        <th
          colSpan="2"
          abbr="Nutritional values for prepared meal (excluding salt & olive oil)"
          scope="col"
        >
          <span className="whitespace-nowrap">As Prepared</span>
        </th>
      </tr>
      <tr className={style.caloriesRow}>
        <th className={style.helvBlk} scope="col">
          Calories
        </th>
        <td className={style.helvBlk} colSpan="2">
          {dailyValueAsPackaged.calories}
        </td>
        <td className={style.helvBlk} colSpan="2">
          {dailyValueAsPrepared.calories}
        </td>
      </tr>
    </tbody>
  );
};

ThreeColumnNutritionTableHeadingRows.propTypes = {
  dailyValueAsPackaged: PropTypes.object.isRequired,
  dailyValueAsPrepared: PropTypes.object.isRequired,
};

const NutritionTableHeadingRows = ({
  isTempo,
  menuCategory,
  needsAllNutritionDetails,
  dailyValueAsPackaged,
  dailyValueAsPrepared,
}) => {
  if (needsAllNutritionDetails) {
    return (
      <ThreeColumnNutritionTableHeadingRows
        dailyValueAsPackaged={dailyValueAsPackaged}
        dailyValueAsPrepared={dailyValueAsPrepared}
      />
    );
  }

  return (
    <SingleColumnNutritionTableHeadingRows
      isTempo={isTempo}
      menuCategory={menuCategory}
      dailyValueAsPackaged={dailyValueAsPackaged}
      dailyValueAsPrepared={dailyValueAsPrepared}
    />
  );
};

NutritionTableHeadingRows.propTypes = {
  isTempo: PropTypes.bool.isRequired,
  menuCategory: PropTypes.string.isRequired,
  needsAllNutritionDetails: PropTypes.bool.isRequired,
  dailyValueAsPackaged: PropTypes.object.isRequired,
  dailyValueAsPrepared: PropTypes.object.isRequired,
};

export default NutritionTableHeadingRows;
